import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const PlayerListPage = () =>
  import('@modules/player/components/player-list-page.vue');
const PlayerFormPage = () =>
  import('@modules/player/components/player-form-page.vue');
const PlayerViewPage = () =>
  import('@modules/player/components/player-view-page.vue');
const PlayerImporterPage = () =>
  import('@modules/player/components/player-importer-page.vue');

export default [
  {
    name: '',
    path: '/subproperty/people/',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'player',
        path: '/player',
        component: PlayerListPage,
        meta: {
          auth: true,
          permission: Permissions.values.playerView,
        },
      },
      {
        name: 'playerNew',
        path: '/player/new',
        component: PlayerFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.playerCreate,
        },
      },
      {
        name: 'playerImporter',
        path: '/player/import',
        component: PlayerImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.playerImport,
        },
      },
      {
        name: 'playerEdit',
        path: '/player/:id/edit',
        component: PlayerFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.playerEdit,
        },
        props: true,
      },
      {
        name: 'playerView',
        path: 'player/:id/:tabName?',
        component: PlayerViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.playerView,
        },
        props: true,
      },
    ],
  },
];
